import React from 'react'
import { Switch, Route } from 'react-router-dom'
import styled from 'styled-components'

import Authorize from 'app/components/Authorize'
import UserAdminContainer from 'app/gears/admin/user/containers/UserAdminContainer'
import AdminGearNav from 'app/gears/admin/components/AdminGearNav'
import UserAdminNav from 'app/gears/admin/user/components/UserAdminNav'
import LandingPage from 'app/gears/admin/components/LandingPage'
import AnnouncementsForm from 'app/gears/admin/announcements/containers/AnnouncementsForm'
import JobsContainer from 'app/gears/admin/jobs/containers/JobsContainer'
import HelpTickets from 'app/gears/admin/help-tickets/HelpTickets'
import EnterpriseSettingsBody from '../enterprise-settings/components/EnterpriseSettingsBody'
import SettingsContainer from '../settings/containers/SettingsContainer'
import { SettingsGearURL } from '../settings/actions/settingsConfig'

/**
 * The root component of the Admin Gear, for application management
 * 
 * @author Alex Clary
 * 
 * TODO: change this Authorize to use functionalities
 * TODO: move this and all children into separate bundle to reduce load time and prevent source from being revealed to all users
 * 
 */
/**/
const AdminGear = () =>
  <Authorize gearAuth={['View Admin Gear']} gearName='administrative functions'>
    <div className='usa-grid'>
      <div className='usa-width-one-sixth'>
        <Switch>
          <Route path='/lgyhub/admin/users/:userId' component={UserAdminNav} />
          <Route component={AdminGearNav} />
        </Switch>
      </div>
      <div className='usa-width-five-sixths'>
        <Route path='/lgyhub/admin/users/:userId?' component={UserAdminContainer} />
        <Route path='/lgyhub/admin/jobs/:jobName?' component={JobsContainer} />
        <Route exact path='/lgyhub/admin/announcements' component={AnnouncementsForm} />
        <Route exact path='/lgyhub/admin/help-tickets/:helpTicketId?' component={HelpTickets} />
        <Route exact path='/lgyhub/admin/' component={LandingPage} />
        <Route path='/lgyhub/admin/enterprise-settings' component={EnterpriseSettingsBody} />
        <Route exact path={[SettingsGearURL.Section, SettingsGearURL.Page]} component={SettingsContainer} />
      </div>
    </div>
  </Authorize>

export default styled(AdminGear)`
  padding-top: 2rem;
  margin-bottom: 5rem;
`
